import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`📥 STEP: Install Prerequisites`}</h2>
    <p>{`In order to gain some time during the course you can pre-install the following prerequisites:`}</p>
    <ul>
      <li parentName="ul">{`ELK - for Log Collection`}</li>
      <li parentName="ul">{`OpenLDAP - for Authentication`}</li>
      <li parentName="ul">{`AWX (Open Source Ansible Tower) with preloaded Playbooks - for Runbook Automation`}</li>
      <li parentName="ul">{`RobotShop and SockShop Demo App`}</li>
    </ul>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Open your Openshift Web Console`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click on the `}<inlineCode parentName="p">{`+`}</inlineCode>{` in the upper right corner`}</p>
        <img parentName="li" {...{
          "src": "./../images/prereqs/01_prereqs.png",
          "alt": "image"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Copy and Paste the code from `}<a href="https://github.com/niklaushirt/ibm-aiops-deployer/blob/main/doc/training/prerequisites-step1.yaml" target="_blank">{`🌏 this file`}</a></p>
      </li>
    </ol>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">
        <p parentName="li">{`Replace the default Password `}<inlineCode parentName="p">{`global_password: CHANGEME`}</inlineCode>{` with a Password of your choice (line 51)`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-yaml"
          }}>{`  global_config:
    # ---------------------------------------------------------------------------------------------------
    # Passwords
    # ---------------------------------------------------------------------------------------------------
    # Use this Password for all Instances
    global_password: CHANGEME
`}</code></pre>
      </li>
    </ol>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">
        <p parentName="li">{`Click `}<inlineCode parentName="p">{`Create`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/prereqs/02_prereqs.png",
          "alt": "image"
        }}></img>
      </li>
    </ol>
    <InlineNotification kind="error" mdxType="InlineNotification">
      <p><strong parentName="p">{`Important - This takes up to 20 minutes`}</strong></p>
      <p>{`This takes some time depending on what infrastructure you have chosen.`}</p>
      <p>{`The installation will run and complete in the background. `}</p>
    </InlineNotification>
    <InlineNotification kind="success" mdxType="InlineNotification">
      <p><strong parentName="p">{`You have successfully finished this Chapter`}</strong></p>
      <p>{`You are now done with installing the Course Prerequisites and are ready to start the course.`}</p>
    </InlineNotification>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      